import { render, staticRenderFns } from "./RoteirizacaoTurnosRaios.vue?vue&type=template&id=15761496&scoped=true&"
import script from "./RoteirizacaoTurnosRaios.vue?vue&type=script&lang=js&"
export * from "./RoteirizacaoTurnosRaios.vue?vue&type=script&lang=js&"
import style0 from "./RoteirizacaoTurnosRaios.vue?vue&type=style&index=0&id=15761496&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15761496",
  null
  
)

export default component.exports